// extracted by mini-css-extract-plugin
var _1 = "footerContactSection-module__contactSection___dunkf";
export { _1 as "contactSection" }
